module.exports = __webpack_public_path__ + "static/media/LOGOS-02.bda03c3f.svg";